import type { SxProps, Theme } from "@mui/material/styles";

export {
  contentCard,
  toolbar,
  toolbarFilters,
  searchWrap,
  paginationFooter,
  paginationCount,
  infoBanner,
  infoBannerText,
  emptyStateCard,
  emptyStateIconWrap,
} from "@/components/Templates/Page/ListPage.styles";

export const noResults: SxProps<Theme> = {
  py: 3,
  textAlign: "center",
  color: "text.secondary",
};

export const emptyActionWrap: SxProps<Theme> = {
  mt: 1.75,
};

export const emptyDescription: SxProps<Theme> = {
  maxWidth: 400,
  lineHeight: 1.8,
};
